module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7414/images/default-avatar.png"